// AuthenticatedLayout.js
import React from 'react';
import { Outlet } from 'react-router-dom';
import { WebSocketProvider } from './WebSocketContext';

const AuthenticatedLayout = () => {
  return (
    <WebSocketProvider>
      <Outlet />
    </WebSocketProvider>
  );
};

export default AuthenticatedLayout;
